import { NonConformityModel } from '../models/non-conformity';

export class NonConformityAdapter {
  static fromApi(data: any): NonConformityModel {
    return {
      id: data.id,
      occurrenceDateTime: data.occurrenceDateTime,
      nonConformityDescription: data.nonConformityDescription,
      originalValue: data.originalValue ?? null,
      nonConformityType: data.nonConformityType,
      resolved: data.resolved
        ? '<span class="badge bg-success px-2 py-2 mx-auto d-block badge-status">Resolvida</span>'
        : '<span class="badge bg-danger px-2 py-2 mx-auto d-block badge-status">Não Resolvida</span>',
      resolvedRaw: !!data.resolved,
      resolutionDateTime: data.resolutionDateTime ?? null,
      stationId: data.stationId ?? null,
      stationName: data.stationName ?? null,
      pluviometricPointId: data.pluviometricPointId ?? null,
      pluviometricPointName: data.pluviometricPointName ?? null,
    };
  }
}
